import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { MonthlyReport, MonthlyReportIndex } from '../models/monthly-report.model';

@Injectable({ providedIn: 'root' })
export class MonthlyReportService {
  private baseUrl = `${environment.apiUrl}/monthlyReports`;

  constructor(private http: HttpClient) {}

  getAdminIndex(ad: number): Observable<MonthlyReportIndex> {
    return this.http.get<MonthlyReportIndex>(`${this.baseUrl}/admin/index/${ad}`);
  }

  getAll(ad: number, isAdmin: boolean = false, isPrev = false, orCreate = false): Observable<MonthlyReportIndex> {
    const params = new HttpParams().set('isAdmin', String(isAdmin)).set('isPrev', String(isPrev)).set('orCreate', String(orCreate));
    return this.http.get<MonthlyReportIndex>(`${this.baseUrl}/admin/${ad}`, { params });
  }

  getLatestAd(isAdmin: boolean = false) {
    const params = new HttpParams().set('isAdmin', String(isAdmin));
    return this.http.get<number>(`${this.baseUrl}/latestAd`, { params });
  }

  update(data: MonthlyReport, status: string, isRebuildMode = false): Observable<MonthlyReport> {
    return this.http.post<MonthlyReport>(`${this.baseUrl}/admin/${data['id']}/${status}/${isRebuildMode}`, data);
  }

  create(data: MonthlyReport, ad: number, isRebuildMode = false): Observable<MonthlyReport> {
    return this.http.post<MonthlyReport>(`${this.baseUrl}/admin/create/${ad}/${isRebuildMode}`, data);
  }

  stepToProcessing(ad: number, status: string): Observable<MonthlyReportIndex> {
    return this.http.get<MonthlyReportIndex>(`${this.baseUrl}/admin/process/${ad}/${status}`);
  }

  getByLoginIdAndAd(login_id: string, ad: number, isAdmin = false) {
    const params = new HttpParams().set('isAdmin', String(isAdmin)).set('ad', String(ad));
    return this.http.get<MonthlyReport[]>(`${this.baseUrl}/${login_id}`, { params });
  }

  getByLoginIdAndCapId(login_id: string, cap_id: string, isAdmin = false) {
    const params = new HttpParams().set('isAdmin', String(isAdmin)).set('cap_id', cap_id);
    return this.http.get<MonthlyReport[]>(`${this.baseUrl}/${login_id}`, { params });
  }

  getAllCapIdByLoginId(login_id: string) {
    return this.http.get<MonthlyReport[]>(`${this.baseUrl}/admin/capids/${login_id}`);
  }

}
